import * as React from "react";
import type { SVGProps } from "react";
const SvgBeach = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#beach_svg__a)">
      <path d="M22.2 19c-.17 0-.35-.05-.5-.13l-10.39-6a1 1 0 0 1-.37-1.37c1.93-3.34 6.22-4.49 9.56-2.56s4.49 6.22 2.56 9.56c-.13.23-.35.4-.61.47-.08.02-.17.03-.26.03zm-8.94-7.32 8.49 4.9c.74-2.21-.15-4.71-2.24-5.91s-4.7-.73-6.24 1.01z" />
      <path d="M18.73 17c-.17 0-.34-.04-.5-.13a1.01 1.01 0 0 1-.37-1.37c1.38-2.39 1.67-4.16 1.59-4.75-.55.22-1.94 1.36-3.32 3.75-.28.48-.89.64-1.37.37a1.01 1.01 0 0 1-.37-1.37c1.74-3.02 4.3-5.6 6.1-4.56.61.35 1.25 1.21.83 3.3-.26 1.27-.87 2.79-1.73 4.27-.19.32-.52.5-.87.5z" />
      <path d="M14 21.2c-.17 0-.34-.04-.5-.13a1.01 1.01 0 0 1-.37-1.37l3-5.2c.28-.48.89-.64 1.37-.37.48.28.64.89.37 1.37l-3 5.2c-.19.32-.52.5-.87.5" />
      <path d="M21 22H3c-.55 0-1-.45-1-1s.45-1 1-1h18c.55 0 1 .45 1 1s-.45 1-1 1" />
      <path d="M9 22h-.14a.995.995 0 0 1-.85-1.13c.98-6.88-.02-9.54-2.81-13.26-.33-.44-.24-1.07.2-1.4s1.07-.24 1.4.2c3.01 4.02 4.26 7.25 3.19 14.74a1 1 0 0 1-.99.86z" />
      <path d="M12 8c-.19 0-.38-.05-.55-.17-2.42-1.61-4.87-.02-4.89 0a1.001 1.001 0 1 1-1.11-1.67c.15-.1 3.59-2.34 7.11 0 .46.31.58.93.28 1.39-.19.29-.51.45-.83.45z" />
      <path d="M5 14c-.55 0-1-.45-1-1 0-3.13 1.01-6.19 1.05-6.32.17-.52.75-.81 1.26-.63.52.17.81.74.63 1.26 0 .03-.95 2.89-.95 5.68 0 .55-.45 1-1 1z" />
      <path d="M6 7.99a1 1 0 0 1-.33-.06.996.996 0 0 1-.62-1.25c.05-.15 1.27-3.58 7.78-4.67.55-.1 1.06.28 1.15.82s-.28 1.06-.82 1.15c-5.22.87-6.21 3.32-6.22 3.35-.15.4-.54.65-.94.65z" />
      <path d="M6 8c-.42 0-.81-.26-.95-.68C5 7.17 3.88 3.71 6.29 1.3A.996.996 0 1 1 7.7 2.71c-1.53 1.53-.76 3.96-.76 3.98A1.006 1.006 0 0 1 5.99 8z" />
      <path d="M1 13c-.1 0-.21-.02-.32-.05a.99.99 0 0 1-.63-1.26c1.12-3.35 5.32-5.49 5.5-5.58a.993.993 0 0 1 1.34.45c.25.49.05 1.09-.45 1.34-.04.02-3.65 1.86-4.5 4.42-.14.42-.53.68-.95.68z" />
      <path d="M1 8c-.37 0-.72-.2-.9-.55a.993.993 0 0 1 .45-1.34c2.34-1.17 5.62-.1 5.76-.05.52.17.81.74.63 1.26s-.74.81-1.26.63c-.73-.24-2.91-.72-4.24-.05-.14.07-.3.11-.45.11z" />
    </g>
    <defs>
      <clipPath id="beach_svg__a">
        <path fill="#fff" d="M0 1h24v21H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgBeach;
